import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

const CourseDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);

  useEffect(() => {
    fetchCourse();
  }, [id]);

  const fetchCourse = async () => {
    const res = await api.get(`/courses/${id}`);
    setCourse(res.data);
  };

  if (!course) return <p>Loading...</p>;

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow rounded-lg">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">{course.title}</h2>
      <p className="mb-6 text-gray-700">{course.description}</p>
      <div className="mb-6">
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => navigate(`/students/dashboard/quizzes?courseId=${id}`)}
        >
          View Quizzes for this Course
        </button>
      </div>
      <button onClick={()=>navigate('/students/dashboard/courses')} className="mt-4 text-blue-500">Back to Courses</button>
    </div>
  );
};

export default CourseDetailPage;
